import { useRef, useState, useContext } from 'react';
import { Button, Dialog, DialogContent, Typography, TextField, CircularProgress } from '@mui/material';
import { Box } from '@mui/system';
import InputMask from 'react-input-mask';
// Our Components
import { CardContext } from 'context/cards/cardContext';
import { UPDATE_CARD_LIST } from 'context/cards/types';
import { useForm } from 'Hooks/useForm';
import SnackBarComponent from 'components/shared/SnackBarComponent';
// Services
import { Cards } from 'lib/api';

export const ActivationModal = ({ open, setOpen, id }) => {
    const { dispatch } = useContext(CardContext);
    const [formValues, handleInputChange] = useForm({
        expiry_date: '',
        last_4: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const snackBarRef = useRef();

    const handleKeyDown = event => {
        if (event.key === 'Tab') {
            event.stopPropagation();
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleActivateCard = async () => {
        try {
            setIsLoading(true);
            const [expiryMonth, expiryYear] = formValues.expiry_date?.split('/');
            const body = {
                expiryMonth: expiryMonth,
                expiryYear: '20' + expiryYear,
                last4: formValues.last_4
            };

            const response = await Cards.activateCard(id, body);
            setIsLoading(false);
            setOpen(false);
            dispatch({
                type: UPDATE_CARD_LIST,
                payload: response
            });
        } catch (error) {
            snackBarRef.current.openSnackBar({
                label: error.response?.data?.message
                    ? error.response?.data?.message
                    : 'There was an error trying to activate the card.',
                severity: 'error'
            });
            setIsLoading(false);
        }
    };

    return (
        <>
            <Dialog open={open} onKeyDown={handleKeyDown} onClose={handleClose} maxWidth="sm" tabIndex="-1">
                <DialogContent>
                    <Typography variant="h6">Activate Card</Typography>
                    <Typography variant="subtitle1">Enter last 4 digits and expiration date.</Typography>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: 'auto 8em',
                            columnGap: '1em',
                            margin: '1.5em 0em'
                        }}>
                        <TextField
                            id="last_4"
                            placeholder="Last 4 digits"
                            variant="outlined"
                            size="small"
                            inputProps={{ maxLength: 4 }}
                            onChange={handleInputChange}
                        />
                        <InputMask mask="99/99" value={formValues.expiry_date} onChange={handleInputChange}>
                            {inputProps => (
                                <TextField {...inputProps} id="expiry_date" placeholder="MM/YY" variant="outlined" size="small" />
                            )}
                        </InputMask>
                    </Box>
                    {isLoading ? (
                        <CircularProgress sx={{ float: 'right' }} />
                    ) : (
                        <Button variant="contained" sx={{ maxWidth: '7em', float: 'right' }} onClick={handleActivateCard}>
                            Activate
                        </Button>
                    )}
                </DialogContent>
            </Dialog>
            <SnackBarComponent ref={snackBarRef} />
        </>
    );
};
